import script from "./no-pass.vue?vue&type=script&lang=tsx&setup=true"
export * from "./no-pass.vue?vue&type=script&lang=tsx&setup=true"

import "./no-pass.vue?vue&type=style&index=0&id=2d6171aa&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d6171aa"]])

export default __exports__